var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-carousel',{attrs:{"trigger":"click","height":_vm.swiperHeight+ 'px'}},_vm._l((4),function(item){return _c('el-carousel-item',{key:item},[_c('img',{ref:"schoolImg",refInFor:true,staticClass:"school_item",attrs:{"src":require("../assets/imgs/school.jpg"),"alt":""}})])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39687e5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ComSwiper.vue
// module id = null
// module chunks = 